import BaseModelAPI from '../BaseModelAPI';

export default class PurchaseRequestDetail extends BaseModelAPI {
	static entity = 'purchaserequestdetail';
	static entityName = 'purchaserequestdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.partId = '';
			this.part = {};
			this.purchaseRequestId = '';
			this.purchaseRequest = {};
			this.partName = '';
			this.qty = 0;
			this.uom = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
			this.partNameCombination = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}